import { PageHeader } from "@idwal/idwal-react-components"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { pathMapper } from "../../utils/pathMapper"
import { AiToggle } from "../AiToggle/AiToggle"
import { GroupDropDown } from "../GroupDropdown/GroupDropDown"
import "./PageHeaderWrapper.css"

export const PageHeaderWrapper = () => {
    const { t } = useTranslation();
    const appAlias = t("pageHeader.appAlias");
    const { pathname } = useLocation();
    let currentPage = pathname.split("/").pop() ?? "";
    currentPage = currentPage === "" ? t("pageHeader.homePage") : currentPage;
    const pathCrumbs = [appAlias, ...pathname.split("/").slice(1, -1)];

    let mappedCurrentPage = pathMapper(currentPage, t) ?? "";
    let mappedPaths = pathCrumbs.map((path) => pathMapper(path, t)) as string[];

    if (currentPage === t("pageHeader.rectifications").toLowerCase()) {
        mappedPaths = [appAlias];
        mappedCurrentPage = t("pageHeader.defects");
    }

    return (
        <PageHeader 
            currentPageCrumb={mappedCurrentPage} 
            pathCrumbs={mappedPaths} 
            rhsInteractiveElements={
                [<AiToggle/>, 
                <GroupDropDown/>]
            }
        />
    )
}